
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","xmlns":"http://www.w3.org/2000/svg","overflow":"visible"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"15","r":"8","fill":"#1CD8AA","stroke":"#FFF","stroke-width":".9"}}),_c('path',{attrs:{"d":"M17.323 10.375c.12 0 .201.132.153.25l-1.51 3.66h3.067c.147 0 .22.19.119.302l-5.17 5.708c-.126.14-.34-.009-.274-.19l1.482-3.987h-2.15c-.115 0-.195-.124-.155-.24l1.87-5.387a.168.168 0 01.155-.116h2.413zm-5.414 3.07v.767h-1.15a.384.384 0 01-.069-.762l.069-.005h1.15zm.768-1.536v.768h-1.918a.383.383 0 01-.069-.761l.069-.007h1.918zm.768-1.534v.767h-2.686a.383.383 0 01-.069-.761l.069-.006h2.686z","fill":"#FFF"}})])
          )
        }
      }
    